import { render } from "./Footer.vue?vue&type=template&id=149cd743&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=149cd743&scoped=true&lang=css"

import exportComponent from "G:\\website\\work\\xmjh\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-149cd743"]])

export default __exports__